<div class="page-container" *ngIf="!isLoading">
    <div class="page-title-container">
        <mat-icon svgIcon="devices" class="page-title-icon" />
        <div>
            {{ 'sidebar.menu.device-managment.label' | translate }}
        </div>
    </div>

    <div class="main-content-container">
        <div class="device-sidebar">
            <div class="add-device-button" (click)="addDevice()">
                {{ 'device-managment.add-button' | translate }}
            </div>
            <div
                *ngFor="let device of deviceList"
                (click)="selectDevice(device)"
                class="equipment"
                [class.selectedDevice]="selectedDevice == device">
                {{ device.name }}
            </div>
        </div>

        <div class="main-content" *ngIf="selectedDevice; else emptyList">
            <div class="title-wrapper">
                <div class="title-container">
                    <div>
                        {{ 'device-managment.models.title' | translate: { device: selectedDevice.name } }}
                    </div>
                    <mat-icon
                        svgIcon="question-mark"
                        class="small-icon"
                        (click)="isInfoMessageVisible = !isInfoMessageVisible; $event.stopPropagation()" />
                    <div class="info-message-container" *ngIf="isInfoMessageVisible">
                        {{ 'device-managment.models.info-1' | translate }}
                        <span class="semibold">
                            {{ 'device-managment.models.info-2' | translate }}
                        </span>
                        {{ 'device-managment.models.info-3' | translate }}
                    </div>
                </div>
                <div class="col-options">
                    <mat-icon
                        svgIcon="more-options"
                        class="icon"
                        style="cursor: pointer"
                        (click)="showDeviceOptions = !showDeviceOptions; $event.stopPropagation()" />
                    <div class="options-container" *ngIf="showDeviceOptions">
                        <div class="option-row" (click)="editDevice()">
                            {{ 'dlg.edit' | translate }}
                        </div>
                        <div class="option-row" (click)="deleteDevice()">
                            {{ 'dlg.delete' | translate }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="add-model-button" (click)="addModel()">
                {{ 'device-managment.models.add-button' | translate: { device: selectedDevice.name } }}
            </div>
            <div class="models-table">
                <div class="model-row table-header">
                    <div class="column model">
                        {{ 'device-managment.models.header.model' | translate: { device: selectedDevice.name } }}
                    </div>
                    <div class="column item-code">
                        {{ 'device-managment.models.header.item-code' | translate }}
                    </div>
                    <div class="column date">
                        {{ 'device-managment.models.header.date' | translate }}
                    </div>
                    <div class="column description">
                        {{ 'device-managment.models.header.description' | translate }}
                    </div>
                    <div class="column col-options"></div>
                </div>
                <ng-container *ngIf="deviceHasNoModels">
                    <div class="empty-models-list">
                        {{ 'device-managment.models.empty-list' | translate }}
                    </div>
                </ng-container>

                <ng-container *ngIf="!deviceHasNoModels">
                    <div
                        *ngFor="let model of selectedDeviceModels; index as i"
                        class="model-row"
                        [class.expanded]="isModelExpanded(model)">
                        <div class="column model semibold">
                            {{ model.name }}
                        </div>
                        <div class="column item-code">
                            {{ model.code }}
                        </div>
                        <div class="column date">
                            {{ model.date }}
                        </div>

                        <app-description-cell
                            class="description"
                            [description]="model.description"
                            [emptyText]="'device-managment.models.empty-description' | translate"
                            (expandedChange)="setModelExpanded(model, $event)"></app-description-cell>

                        <div class="column col-options" #optionsCol>
                            <mat-icon
                                svgIcon="more-options"
                                class="icon"
                                (click)="$event.stopPropagation(); openModelOptions(model, i)" />
                            <div
                                class="options-container"
                                [style.position]="'fixed'"
                                [style.top]="optionsTop"
                                [style.right]="'unset'"
                                *ngIf="openedModelOptions == model">
                                <div class="option-row" (click)="editModel(model)">
                                    {{ 'dlg.edit' | translate }}
                                </div>
                                <div class="option-row" (click)="deleteModel(model)">
                                    {{ 'dlg.delete' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="isLoading"> <app-loading-spinner class="spinner-loading"></app-loading-spinner></ng-container>

<ng-template #emptyList>
    <div class="main-content">
        <div class="empty-list-text">
            {{ 'device-managment.device.empty-list' | translate }}
        </div>
    </div>
</ng-template>
